import { render, staticRenderFns } from "./ConfirmProcessingModal.vue?vue&type=template&id=2828c9bb&"
import script from "./ConfirmProcessingModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ConfirmProcessingModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports